import { render, staticRenderFns } from "./RetailerRegistrationForm.vue?vue&type=template&id=38196de2&lang=pug"
import script from "./RetailerRegistrationForm.vue?vue&type=script&lang=js"
export * from "./RetailerRegistrationForm.vue?vue&type=script&lang=js"
import style0 from "./RetailerRegistrationForm.vue?vue&type=style&index=0&id=38196de2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports